
import { defineComponent } from 'vue';

import { images } from './assets/images';

export default defineComponent({
  name: 'LayeredHeadings',

  data: () => ({
    images
  })
});
